module.exports = __webpack_public_path__ + "static/media/foundation_image.9aeb4dc1.png";